import {
	EXPAND,
	FOLD,
	EXPORT,
	EDGEWIDTH,
	TOOLTIP,
	FLEXPATHS,
	HIGHLIGHTFLEXPATHS,
	STRATEGYSUMMARY,
	CYCLE,
	LATEST,
	LEGEND,
	TOGGLEVIEW,
} from "./actions/strategyActions";
import { SAVE, SAVEDISABLED, LOAD, PREV, NEXT } from "./actions/general";
const config = {
	general: {
		SAVE,
		SAVEDISABLED,
		LOAD,
		PREV,
		NEXT,
	},
	strategy: {
		EXPAND,
		FOLD,
		EXPORT,
		STRATEGYSUMMARY,
		LEGEND,
		CYCLE,
		EDGEWIDTH,
		TOOLTIP,
		FLEXPATHS,
		HIGHLIGHTFLEXPATHS,
		LATEST,
		TOGGLEVIEW,
	},
};

export default config;
